const setStatusFilter = status => ({
  type: 'COMMENT_FILTER:SET_STATUS',
  data: { status }
})

const setSearchValue = searchValue => ({
  type: 'COMMENT_FILTER:SET_SEARCH_VALUE',
  searchValue
})

export { setStatusFilter, setSearchValue }
